import { render, staticRenderFns } from "./blissdom copy.vue?vue&type=template&id=068c8bac&scoped=true&"
import script from "./blissdom copy.vue?vue&type=script&lang=js&"
export * from "./blissdom copy.vue?vue&type=script&lang=js&"
import style0 from "./blissdom copy.vue?vue&type=style&index=0&id=068c8bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068c8bac",
  null
  
)

export default component.exports